import Vue from "vue";
import Guid from "../../helpers/guid";
import TrackedModel from "../tracked/trackedModel";
import { ConditionalFieldDefinition } from "./conditionalFieldDefinition";
import IConditionalRuleContainer from "./conditionalRuleContainer";
import ConditionalRuleFactory from "./conditionalRuleFactory";
import ConditionalRuleSet from "./conditionalRuleSet";
import { DisplayRuleType } from "./displayRuleType";
import { JoinType } from "./joinType";

export default class ConditionalRuleSetFactory {
  private constructor() {}

  static createForRuleSet(
    conditionalRuleSet: ConditionalRuleSet,
    json: object,
    isAttached: boolean = false,
    createWithRule: boolean = false,
    fieldName: string,
    isNew: boolean = false,
  ): ConditionalRuleSet {
    const crs = conditionalRuleSet.createNew(fieldName, conditionalRuleSet.conditionalFieldDefinition);

    crs.rootModel = conditionalRuleSet.rootModel;
    crs.parent = conditionalRuleSet;

    crs.defineProperty('client_id', json['client_id'] || Guid.create());
    crs.defineProperty('display_type', DisplayRuleType.show, !isAttached);
    crs.defineProperty('join_type', JoinType.and, !isAttached);
    crs.defineProperty('sort_order', conditionalRuleSet.nextRuleSortOrder(), isNew);


    if (isAttached) {
      crs.repo.add(crs);
    }
    Vue.set(conditionalRuleSet.conditional_rules, crs.client_id, crs);

    if (createWithRule) {
      ConditionalRuleFactory.create(crs, {}, isAttached, isNew);
      ConditionalRuleFactory.create(crs, {}, isAttached, isNew);
    }

    return crs;
  }

  static createForContainer(
    parent: IConditionalRuleContainer,
    definition: ConditionalFieldDefinition,
    json: object,
    isAttached: boolean = false,
    createWithRule: boolean = false,
    isNew: boolean = false,
  ): ConditionalRuleSet {
    const crs = parent.createNewRuleSet(definition.fieldName, definition);

    crs.rootModel = parent.rootModel;

    crs.defineProperty('client_id', json['client_id'] || Guid.create());
    crs.defineProperty('display_type', DisplayRuleType.show, !isAttached);
    crs.defineProperty('join_type', JoinType.and, !isAttached);
    crs.defineProperty('sort_order', Object.keys(parent.getConditionalRuleSets(definition.fieldName)).length);

    this.getAndDefineDefaultConditionalValue(crs, definition);

    if (createWithRule) {
      ConditionalRuleFactory.create(crs, {}, isAttached, isNew);
    }

    return crs;
  }

  private static getAndDefineDefaultConditionalValue(
    parent: TrackedModel,
    definition: ConditionalFieldDefinition
  ) {
    if (definition.defaultConditionalValue instanceof Function) {
      const conditionalValueObject = definition.defaultConditionalValue(parent, {});
      conditionalValueObject.parent = parent;
      Vue.set(parent, 'conditional_value', conditionalValueObject);
    } else {
      parent.defineProperty('conditional_value', definition.defaultConditionalValue);
    }
    parent.defineProperty('conditional_value_formula', '');
  }
}